import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faFacebook, faYoutube, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import maze from '../images/maze.jpg'
import { Link } from 'react-router-dom';
import newLogo from '../images/landscape-black-logo.png'
import purplelogo from '../images/purple-logo.png'
import darklogo from '../images/dark-logo.png'



export default function Footer() {
   
  return (
    <>
      <footer className="footer-main text-white" style={{background: 'linear-gradient(135deg, #181818 60%, #7E014D 100%)', fontFamily: 'Inter, Arial, sans-serif', letterSpacing: '0.01em'}}>
        {/* Section: Social media */}
        <section className="footer-social d-flex justify-content-center align-items-center py-4 border-bottom" style={{borderColor: 'rgba(255,255,255,0.08)'}}>
          <div className="me-5 d-none d-lg-block" style={{fontWeight: 500, fontSize: '1.1rem', color: '#fff'}}>
            Get connected with us on social networks:
          </div>
          <div>
            <a href="https://api.whatsapp.com/send?phone=918789541680" className="footer-icon-link me-3">
              <FontAwesomeIcon icon={faWhatsapp} size='xl' />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100063877067060" className="footer-icon-link me-3">
              <FontAwesomeIcon icon={faFacebook} size='xl'/>
            </a>
            <a href="https://twitter.com/SELLERSGUIDESOL" className="footer-icon-link me-3">
              <FontAwesomeIcon icon={faTwitter} size='xl'/>
            </a>
            <a href="https://www.youtube.com/mazeflip" className="footer-icon-link me-3">
              <FontAwesomeIcon icon={faYoutube} size='xl'/>
            </a>
            <a href="https://www.instagram.com/sellersguidesolution" className="footer-icon-link">
              <FontAwesomeIcon icon={faInstagram} size='xl'/>
            </a>
          </div>
        </section>
        {/* Section: Social media */}

        {/* Section: Links  */}
        <section className="footer-links">
          <div className="container py-5">
            <div className="row g-4">
              {/* Logo & About */}
              <div className="col-12 col-md-6 col-lg-3">
                <div className="mb-3">
                  <img src={darklogo} alt="Mazeflip Logo" style={{maxWidth:'170px'}} className='img-fluid'/>
                </div>
                <p style={{fontSize: '0.98rem', color: '#d1d1d1', lineHeight: 1.7}}>
                  Empowering Businesses to Thrive in the Digital Realm! Offering premier solutions in e-commerce marketing, digital marketing, and cutting-edge website design and development services that drive tangible results and open doors to boundless possibilities.
                </p>
              </div>
              {/* Our Services */}
              <div className="col-6 col-md-6 col-lg-3">
                <h6 className="footer-title mb-4" style={{color:"#fff", fontWeight: 700, letterSpacing: '0.05em', fontSize: '1.1rem'}}>
                  OUR SERVICES
                </h6>
                <ul className="list-unstyled">
                  <li><a href="/amazon" className='footer-link'>Amazon</a></li>
                  <li><a href="/flipkart" className='footer-link'>Flipkart</a></li>
                  <li><a href="/ecommerce" className='footer-link'>E-commerce Marketing</a></li>
                  <li><a href='/web-dev' className='footer-link'>Web Development</a></li>
                  <li><a href='/digital-market' className='footer-link'>Digital Marketing</a></li>
                  <li><a href='/nykaa' className='footer-link'>Nykaa</a></li>
                  <li><a href='/jiomart' className='footer-link'>Jio Mart</a></li>
                </ul>
              </div>
              {/* Quick Links */}
              <div className="col-6 col-md-6 col-lg-3">
                <h6 className="footer-title mb-4" style={{color:"#fff", fontWeight: 700, letterSpacing: '0.05em', fontSize: '1.1rem'}}>
                  QUICK LINKS
                </h6>
                <ul className="list-unstyled">
                  <li><a href='/about' className='footer-link'>About us</a></li>
                  <li><a href='/contacts' className='footer-link'>Contact us</a></li>
                </ul>
              </div>
              {/* Contact Us */}
              <div className="col-12 col-md-12 col-lg-3">
                <h6 className="footer-title mb-4" style={{color:"#fff", fontWeight: 700, letterSpacing: '0.05em', fontSize: '1.1rem'}}>
                  CONTACT US
                </h6>
                <address style={{fontSize: '0.97rem', color: '#d1d1d1', lineHeight: 1.7}}>
                  MAZEFLIP SERVICES,<br/>
                  Ward No-20 ,<br/>
                  Sultanpur, East Matth,<br/>
                  PO Danapur Cantt,<br/>
                  Patna, Bihar,<br/>
                  PIN:801503
                </address>
                <div className="mb-2">
                  <i className="bi bi-telephone-fill"></i>
                  <a href='tel:+918789541680' className='footer-link ms-2'>8789541680</a>
                </div>
                <div>
                  <a href='mailto:contact@mazeflipservices.com' className="footer-link">
                    <i className="bi bi-envelope-at-fill"></i> contact@mazeflipservices.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Section: Links  */}

        {/* Copyright */}
        <div className="footer-copyright text-center py-3" style={{ backgroundColor: 'rgba(255,255,255,0.03)', color: '#bdbdbd', fontSize: '0.97rem', letterSpacing: '0.03em' }}>
          <p className="mb-0">&copy; {new Date().getFullYear()} Mazeflip Services. All rights reserved.</p>
        </div>
      </footer>

      {/* Inline styles for professional look */}
      <style>{`
        .footer-main {
          box-shadow: 0 0 40px 0 rgba(0,0,0,0.18);
        }
        .footer-title {
          text-transform: uppercase;
          border-left: 4px solid #7E014D;
          padding-left: 10px;
        }
        .footer-link {
          display: block;
          color: #bdbdbd !important;
          text-decoration: none;
          margin-bottom: 0.5rem;
          font-size: 0.98rem;
          transition: color 0.2s;
        }
        .footer-link:hover {
          color: #fff !important;
          text-decoration: underline;
        }
        .footer-icon-link {
          color: #fff;
          background: #7E014D;
          border-radius: 50%;
          width: 38px;
          height: 38px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.3rem;
          margin-right: 8px;
          transition: background 0.2s, color 0.2s, transform 0.2s;
          box-shadow: 0 2px 8px 0 rgba(126,1,77,0.08);
        }
        .footer-icon-link:hover {
          background: #fff;
          color: #7E014D;
          transform: translateY(-2px) scale(1.08);
          text-decoration: none;
        }
        @media (max-width: 991px) {
          .footer-links .row > div {
            margin-bottom: 2rem;
          }
        }
      `}</style>
    </>
  )
}
